import React from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { MAX_QUANTITY } from './Constants';

function FormatSelector({
  book,
  format,
  quantity,
  price,
  couponDiscount,
  isPaperbackComingSoon,
  onSelectDigital,
  onSelectPaper,
  onQuantityChange,
}) {
  return (
    <>
      <div className="format-pill" role="radiogroup" aria-label="Choose a format">
        <button
          type="button"
          role="radio"
          aria-checked={format === 'digital'}
          className={`format-pill-btn ${format === 'digital' ? 'active' : ''}`}
          onClick={onSelectDigital}
        >
          E-Book
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={format === 'paper'}
          className={`format-pill-btn ${format === 'paper' ? 'active' : ''} ${
            isPaperbackComingSoon ? 'coming-soon' : ''
          }`}
          onClick={onSelectPaper}
        >
          Paperback
          {isPaperbackComingSoon && <span className="format-pill-badge">Soon</span>}
        </button>
      </div>

      {format === 'paper' && !isPaperbackComingSoon && (
        <div className="quantity-control">
          <button
            type="button"
            aria-label="Decrease quantity"
            onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
          >
            <FaMinus />
          </button>
          <span>{quantity}</span>
          <button
            type="button"
            aria-label="Increase quantity"
            onClick={() => onQuantityChange(Math.min(MAX_QUANTITY, quantity + 1))}
          >
            <FaPlus />
          </button>
        </div>
      )}

      <div className="price-display">
        {couponDiscount > 0 ? (
          <>
            <span className="price-original">{book.priceDigital.toLocaleString()} DA</span>
            <span className="price-current">{price.toLocaleString()} DA</span>
          </>
        ) : (
          <span className="price-current">{price.toLocaleString()} DA</span>
        )}
      </div>
      <p className="price-caption">
        {format === 'digital'
          ? 'PDF or ePub, delivered by email'
          : `Printed copy${quantity > 1 ? ` × ${quantity}` : ''}, delivered to your door`}
      </p>
    </>
  );
}

export default FormatSelector;